<div class="sidebar" [class.open]="isOpen">
  <div class="logo">
    <img src="/img/LOGO.png" alt="Const Insight" class="logo-img" />
    <span>Costos integrales</span>
  </div>

  <nav class="menu">
    <!-- ITEMS DIRECTOS -->
    @for (path of standalonePaths; track path) {
      @let route = getRoute(path);
      @if (route) {
        <a class="list" [routerLink]="['/', route.path]" routerLinkActive="active">
          <mat-icon>{{ resolveIcon(route) }}</mat-icon>
          <span>{{ route.data.key | term: route.data.menuText ?? '' }}</span>
        </a>
      }
    }

    <!-- SECCIONES AGRUPADAS -->
    @for (section of sections; track section.key) {
      <div class="menu-section">
        <button class="section-header" (click)="toggleSection(section)">
          <mat-icon>{{ section.icon }}</mat-icon>
          <span>{{ section.key | term: section.title }}</span>
          <mat-icon class="chevron" [class.rotated]="section.expanded">expand_more</mat-icon>
        </button>

        @if (section.expanded) {
          <div class="section-items">
            @for (path of section.paths; track path) {
              @let route = getRoute(path);
              @if (route) {
                <a class="list" [routerLink]="['/', route.path]" routerLinkActive="active">
                  <mat-icon>{{ resolveIcon(route) }}</mat-icon>
                  <span>{{ route.data.key | term: route.data.menuText ?? '' }}</span>
                </a>
              }
            }
          </div>
        }
      </div>
    }
  </nav>
</div>
